import { Wishlist, Cart, ResponseError, nativeAppHeaders } from '@ynap/api-utils'
import { timeout, delay } from '@ynap/promise-utils'
import { redirectToLogin } from '@ynap/redirect-utils'
import { MOVE_TO_WISHLIST_REQUEST, MOVE_TO_WISHLIST_SUCCESS, MOVE_SOLD_OUT_TO_WISHLIST_SUCCESS, MOVE_TO_WISHLIST_ERROR } from '../constants/ActionTypes'
import { notifyBasketChanged, getLocale } from '@ynap/cart-state'
import { getWatsonConfig, getTimeout, getDelay } from '@ynap/cart-state/src/selectors/getConfig'
import fetchCart from '../actions/fetchCart'
import { getAdditionalCheckoutHeaders } from '../utils/checkoutActionUtils'

export default function moveToWishlist(partNumber, orderItemId, soldOut, quantity, clearMessages = false) {
    return (dispatch, getState, fetch) => {
        const state = getState()
        const watsonConfig = getWatsonConfig(state)
        const locale = getLocale(state)
        const additionalHeaders = {
            ...nativeAppHeaders(state.deviceType),
            ...getAdditionalCheckoutHeaders(state)
        }

        dispatch(moveToWishlistRequest(partNumber))

        const addToWishlistRequest = Wishlist.addItems({ items: [{ partNumber }], ...watsonConfig })
        const getWishlistRequest = Wishlist.getPrimaryWishlist(watsonConfig)

        function removeFromCart(giftListItemID, alreadyInWishlist, soldOut) {
            if (soldOut) {
                return dispatch(moveSoldOutToWishlistSuccess(partNumber, giftListItemID, alreadyInWishlist))
            }

            const removeFromCartRequest = Cart.deleteOrderItem({ partNumber, orderItemId, quantity, ...watsonConfig, langId: locale.langId, additionalHeaders })
            return timeout(fetch(removeFromCartRequest), getTimeout(state)).then((removeFromCartResponse) => {
                if (!removeFromCartResponse.ok) {
                    throw new ResponseError(removeFromCartResponse)
                }
                return removeFromCartResponse.json().then((cartData) => {
                    dispatch(moveToWishlistSuccess(partNumber, orderItemId, cartData, giftListItemID, alreadyInWishlist))
                    notifyBasketChanged()
                })
            })
        }

        if (state.cart.x_userStatus !== 'R') {
            const redirect = `${window.location.pathname}?wishlistItem=${encodeURIComponent(partNumber)}&mode=addToWishlist`
            return redirectToLogin(locale.id, { redirect })
        }

        return delay(
            timeout(fetch(addToWishlistRequest), getTimeout(state))
                .then((addToWishlistResponse) => {
                    if (addToWishlistResponse.ok) {
                        return addToWishlistResponse.json().then(({ item }) => removeFromCart(item[0].giftListItemID, false, soldOut))
                    }

                    return addToWishlistResponse.json().then((data) => {
                        const { errors } = data
                        if (errors?.length) {
                            const { errorMessage } = errors[0]
                            if (errorMessage === 'ERR_SKU_ALREADY_EXISTS') {
                                return timeout(fetch(getWishlistRequest), getTimeout(state)).then((wishlistResponse) => {
                                    if (!wishlistResponse.ok) {
                                        throw new ResponseError(wishlistResponse)
                                    }

                                    return wishlistResponse.json().then(({ GiftList }) => {
                                        const { giftListItemID } = GiftList[0].item.find((giftListItem) => giftListItem.partNumber === partNumber)
                                        return removeFromCart(giftListItemID, true, soldOut)
                                    })
                                })
                            } else if (errorMessage === 'ERR_WISH_LIST_MAX_WISH_LIST_ITEMS_REACHED') {
                                throw new Error('wishlist full')
                            }
                        }
                        throw new ResponseError(addToWishlistResponse)
                    })
                })
                .then((result) => {
                    if (clearMessages) {
                        dispatch(fetchCart({ clearMessages }))
                    }

                    return result
                })
                .catch((error) => {
                    dispatch(moveToWishlistError(partNumber, error))
                    throw error
                }),
            getDelay(state)
        )
    }
}

function moveToWishlistRequest(partNumber) {
    return {
        type: MOVE_TO_WISHLIST_REQUEST,
        partNumber,
    }
}

function moveToWishlistSuccess(partNumber, orderItemId, payload, giftListItemID, alreadyInWishlist) {
    return {
        type: MOVE_TO_WISHLIST_SUCCESS,
        partNumber,
        orderItemId,
        payload,
        giftListItemID,
        alreadyInWishlist,
    }
}

function moveSoldOutToWishlistSuccess(partNumber, giftListItemID, alreadyInWishlist) {
    return {
        type: MOVE_SOLD_OUT_TO_WISHLIST_SUCCESS,
        partNumber,
        giftListItemID,
        alreadyInWishlist,
    }
}

function moveToWishlistError(partNumber, error) {
    return {
        type: MOVE_TO_WISHLIST_ERROR,
        partNumber,
        error,
    }
}
